import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { ClassConstructor } from "../../../library-js/tools/TypeUtilities";
import { CarouselElement } from "./CarouselElement";
import { CarouselSelect } from "./CarouselSelect";
import { SlideUp } from "./types/SlideUp";
import { ZoomLayers } from "./types/ZoomLayers";

export type CarouselElementCreator = (s:CarouselSelect, e:Element)=>CarouselElement;
export class CarouselElementType
{
  static flag = new ClassFlag( "carousel-element" );

  static types:{type:ElementType<any>,creator:CarouselElementCreator}[] =
  [
    {
      type:ZoomLayers.type,
      creator: (s,e)=>new ZoomLayers( s, e )
    },

    {
      type:SlideUp.type,
      creator: (s,e)=> new SlideUp( s, e )
    }
  ];

  static create( select:CarouselSelect, element:Element ):CarouselElement
  {
    let carouselElement = CarouselElementType.flag.query( element );

    let type = CarouselElementType.types.find( t => t.type.is( carouselElement ) );

    if ( type )
    {
      return type.creator( select, carouselElement );
    }

    return null;
  }
}